import * as stylex from '@stylexjs/stylex';
import { jsx as _jsx } from "react/jsx-runtime";
const internalIconWrapperStyles = {
  base: {
    display: "x1rg5ohu",
    lineHeight: "x14ju556",
    $$css: true
  },
  alignWithText: {
    verticalAlign: "x1x7wgjd",
    $$css: true
  }
};
export const InternalIconWrapper = ({
  alignWithText,
  xstyle,
  children
}) => {
  return /*#__PURE__*/_jsx("span", Object.assign({}, stylex.props(internalIconWrapperStyles.base, alignWithText && internalIconWrapperStyles.alignWithText, xstyle), {
    children: children
  }));
};